import { LOCAL_STORAGE_KEYS } from '../../constants/AppConstants';
import { PBStorage } from '../../services/storageService/GlobalData';

class WorkerManager {
  /**
   * Save single modules metadata
   */
  async saveMetaData(metaData) {
    try {
      let metaDataList = await PBStorage.get(LOCAL_STORAGE_KEYS.META_DATA);
      if (metaDataList && metaDataList.length > 0) {
        metaDataList =
          metaDataList.filter((q) => q.moduleName != metaData.moduleName) || [];
        metaDataList.push(metaData);
        await PBStorage.set(LOCAL_STORAGE_KEYS.META_DATA, metaDataList);
      } else {
        await PBStorage.set(LOCAL_STORAGE_KEYS.META_DATA, [metaData]);
      }
      return true;
    } catch (e) {
      console.log('saveMetaDatafailed', e);
      return false;
    }
  }

  /**
   * Return Realm Object a specific module
   * @param {*} moduleName
   */
  async getMetaDataByModule(moduleName) {
    try {
      let metaData = (await PBStorage.get(LOCAL_STORAGE_KEYS.META_DATA)) || [];

      metaData = metaData.find((q) => q.moduleName == moduleName);
      return metaData;
    } catch (e) {
      return null;
    }
  }
}

export default new WorkerManager();
